import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import { Link } from 'react-router';

import Loading from '../../components/Loading';
import Page from '../Page';
import ErrorPage from '../../components/ErrorPage';
import Statuses from '../Statuses';
import ChannelName from '../../components/ChannelName';
import clientFormatter from '../../utils/clientFormatter';
import teamIdFromAuth from '../../enhancers/teamIdFromAuth';
import { channelPath, teamMetaPath } from '../../utils/firebasePaths';

const { isLoaded, isEmpty, dataToJS } = helpers;

@teamIdFromAuth()
@fb(({ params: { channelId }, teamId }) => [
  channelPath({ channelId, teamId }),
  `${teamMetaPath(teamId)}/client`,
  `${teamMetaPath(teamId)}/name`,
])
@connect(
  ({ firebase }, { params: { channelId }, teamId }) => ({
    channel: dataToJS(firebase, channelPath({ channelId, teamId })),
    client: dataToJS(firebase, `${teamMetaPath(teamId)}/client`),
    teamName: dataToJS(firebase, `${teamMetaPath(teamId)}/name`),
  })
)
export default class ChannelList extends Component {
  static propTypes = {
    channel: PropTypes.object,
    children: PropTypes.node,
    client: PropTypes.string,
    params: PropTypes.shape({
      channelId: PropTypes.string.isRequired,
    }).isRequired,
    teamId: PropTypes.string.isRequired,
    teamName: PropTypes.string,
  }

  render() {
    const {
      channel,
      client,
      teamName,
      params: { channelId },
      teamId,
    } = this.props;

    if (!isLoaded(channel) || !isLoaded(teamName)) {
      return <Loading />;
    }

    if (isEmpty(channel)) {
      return (
        <ErrorPage
          pageTitle="Channel Not Found"
          title="Channel Not Found"
        >
          <Link
            className="b white no-underline app-bg-blue pa3 br2 center dib mt3"
            to="/dashboard"
          >
            Back to Dashboard
          </Link>
        </ErrorPage>
      );
    }

    const { name } = channel;
    const formatter = clientFormatter(client);
    const title = `${formatter.channelName(name)} · ${teamName}`;

    return (
      <Page pageTitle={title}>
        <div className="dt-ns dt--fixed-ns">
          <div className="dtc-ns w-20-ns">
            <Link
              className="mid-gray navy no-underline f6"
              to="/dashboard"
            >
              &larr; Back to Dashboard
            </Link>
          </div>
          <div className="dtc-ns w-80-ns mt3 mt0-ns">
            <div className="bb b--black-10 pb3">
              <ChannelName className="navy f4 b" client={client} name={name} />
            </div>
            <Statuses channelId={channelId} teamId={teamId} />
          </div>
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Channel/index.jsx
 **/